import React, { useContext } from "react";
import "./SubModel.scss";
import { Context } from "../Store";
import { Link } from "react-router-dom";

const SubModel = ({ title, price, duration, features }) => {
  const { dir, siteInfoRes } = useContext(Context);
  return (
    <div className="sub-model">
      <div className="sub-model-head">
        <h3 className="sub-title">{title}</h3>
        <span className="sub-details">{dir === "ltr" ? "SAR" : "ر.س"} </span>
        <span className="sub-price">{price} </span>
        <span className="sub-details"> / {duration} </span>
      </div>
      <div className="sub-model-features">
        {features.map((feature, index) => (
          <div className="sub-model-feature" key={index}>
            <ul>
              <li>
                <i
                  className={
                    dir === "ltr"
                      ? `fa-solid fa-check margin-left`
                      : `fa-solid fa-check margin-right`
                  }
                  style={{ color: "#2a9d7c" }}
                ></i>
              </li>
            </ul>
            <ul>
              <li>{feature?.name}</li>
            </ul>
            {/* <p>{feature?.name}</p> */}
          </div>
        ))}
      </div>
      <div className="sub-model-btn">
        <a target="_blank" href={siteInfoRes?.googlePlay}>
          <button className="sub-btn">
            {dir === "ltr" ? "Select Package" : "اختر الباقة"}
          </button>
        </a>
      </div>
    </div>
  );
};

export default SubModel;
